import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HvlNgSharedModule, PrimengSharedModule } from '@hvlng/framework-core/shared';
import { UiConfirmationDialogService, UiSharedModule } from 'ui-shared';
import { TranslateModule } from '@ngx-translate/core';
import { HvlFormItemModule, HvlFormMessageModule } from '@hvlng/framework-core/form';
import { HrGalleriaExtendedComponent } from './hr-galleria-extended.component';
import { GalleriaModule } from 'primeng/galleria';
import { DialogService, DynamicDialogModule, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FileUploadModule } from 'primeng/fileupload';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
    declarations: [HrGalleriaExtendedComponent],
    imports: [
        CommonModule,
        PrimengSharedModule,
        HvlNgSharedModule,
        UiSharedModule,
        TranslateModule,
        HvlFormItemModule,
        DynamicDialogModule,
        FormsModule,
        ReactiveFormsModule,
        HvlFormMessageModule,
        HvlFormItemModule,
        GalleriaModule,
        FileUploadModule,
    ],
    exports: [HrGalleriaExtendedComponent],
    providers: [DialogService, UiConfirmationDialogService, DynamicDialogRef],
})
export class HrGalleriaExtendedModule {}
